module.exports = __webpack_public_path__ + "img/product2.3a637504.png";